import { createFileRoute, Outlet } from "@tanstack/react-router";
import { type } from "arktype";

const validateSearch = type({
  "message?": "string",
  "to?": "string",
});

export const Route = createFileRoute("/_unauthed/login")({
  component: RouteComponent,
  validateSearch,
});

function RouteComponent() {
  return <Outlet />;
}
